import React from "react";
import Loader from 'react-loader-spinner';
import './deposit.scss';

import Button from '../../Form/Button/Button';
import ButtonGroup from '../../Form/Button/ButtonGroup';
import CurrencyInput from '../../Form/TextInput/CurrencyInput';
import chevRight from '../../../assets/images/chev-right-royal.svg';
import copyIcon from '../../../assets/images/copy-icon.svg';

import { formatCurrency, canCopyToClipboard, copyToClipboard } from '../../../utils/helpers';

class Deposit extends React.Component {
  state = { step: 0, amount: null };

  getInputClassNames() {
    const { amount } = this.state;
    let names = ["withdraw__input"];
    if (amount) {
      names.push('withdraw__input--filled');
    }
    return names.join(' ');
  }

  onConfirm = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
    event.preventDefault();
    if (this.state.amount) {
      this.setState({ step: 2 }, () => {
        setTimeout(() => this.goToStepThree(), 1000);
      });
    }
    return false;
  }

  onDone = (/** @type {React.FormEvent<HTMLFormElement>} */ event) =>  {
    event.preventDefault();
    const { account, onDone } = this.props;
    if (typeof onDone === 'function') onDone(account);
    return false;
  }

  onCancel = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
    event.preventDefault();
    const { account, onCancel } = this.props;
    if (typeof onCancel === 'function') onCancel(account);
    return false;
  }

  // @ts-ignore
  onAmountChange = amount => this.setState({ amount: parseFloat(amount.replace(/,/g, '')) });

  goToStepOne = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
    event.preventDefault();
    this.setState({ step: 1 });
    return false;
  }

  goToStepThree = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
    event.preventDefault();
    this.setState({ step: 3 });
    return false;
  }

  copyAccountNumber = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
    event.preventDefault();
    copyToClipboard(this.props.account.number);
    return false;
  }
  
  copySortCode = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
    event.preventDefault();
    copyToClipboard(this.props.account.sortCode);
    return false;
  }

  renderStepZero() {
    const { account } = this.props;
    return (
      <form className="deposit" 
        onSubmit={this.onDone}>
        <div className="deposit__section">
          <h3 className="deposit__title">Deposit</h3>
          <div className="deposit__balance">
            <span className="deposit__balance-key">{account.name}</span>
            <span className="deposit__balance-value">{formatCurrency(account.balance)}</span>
          </div>
        </div>
        <div className="deposit__divider" />
        <div className="deposit__section">
          <div className="deposit__paragraph">Please use these details to make a deposit or you can do this now via <a href='#' onClick={this.goToStepOne}>mobile <img src={chevRight} /></a></div>
        </div>
        <div className="deposit__divider" />
        <div className="deposit__section">
          <div className="deposit__line"><strong>Investec Online Flexi Saver</strong></div>
          <div className="deposit__copy-line">
            {canCopyToClipboard() && <a href="#" onClick={this.copyAccountNumber}><img src={copyIcon} /></a>}
            <span>Account # {account.number}</span>
          </div>
          <div className="deposit__copy-line">
            {canCopyToClipboard() && <a href="#" onClick={this.copySortCode}><img src={copyIcon} /></a>}
            <span>Sort Code {account.sortCode}</span>
          </div>
        </div>
        <div className="deposit__actions">
          <ButtonGroup noGutter>
            <Button size='med' type="submit" label="Done" customClassNames={['deposit__action',]} />
          </ButtonGroup>
        </div>
      </form>
    );
  }

  renderStepOne() {
    const { account, toAccount } = this.props;
    const { amount } = this.state;
    return (
      <form className="deposit" 
// @ts-ignore
      onSubimt={this.onConfirm}>
        <div className="deposit__section">
          <h3 className="deposit__title">Deposit</h3>
          <div className="deposit__balance">
            <span className="deposit__balance-key">{toAccount.name}</span>
            <span className="deposit__balance-value">{toAccount.sortCode}</span>
          </div>
          <div className="deposit__balance">
            <span className="deposit__balance-key">Account # </span>
            <span className="deposit__balance-value">{toAccount.accountNumber}</span>
          </div>
        </div>
        <div className="deposit__divider" />
        <div className="deposit__section deposit__section--with-arrow">
          <div className="deposit__line"><strong>To Account</strong></div>
          <div className="deposit__line">{account.name}</div>
          <div className="deposit__line">Balance {formatCurrency(account.balance)}</div>
        </div>
        <div className="deposit__divider" />
        <div className="deposit__section deposit__section--horizontal">
          <CurrencyInput
            onChange={this.onAmountChange}
            placeholder="Amount"
          />
          <div className="deposit__actions">
            <ButtonGroup noGutter>
              <Button  size='sml' type="submit" label="Confirm" customClassNames={['deposit__action']} disabled={!amount} />
              <Button  variant='secondary' size='sml' type="button" label="Cancel" customClassNames={['deposit__action']} onClick={this.onCancel} />
            </ButtonGroup>
          </div>
        </div>
      </form>
    );
  }

  renderStepTwo() {
    return (
      <div className="deposit">
        <div className="deposit__section deposit__section--wider">
          <h3 className="deposit__title">Initiate Payment</h3>
        </div>
        <div className="deposit__divider" />
        <div className="deposit__section deposit__section--wider">
          <div className="deposit__paragraph deposit__paragraph--full-width">
            We have started the process and you will be redirected to your bank to continue the process.
            <a className="deposit__try-again" href="#" onClick={this.goToStepOne}>Try again <img src={chevRight} /></a>
          </div>
        </div>
        <div className="deposit__divider" />
        <div className="deposit__section deposit__section--fill-remaining">
          <Loader type="Triangle" color="#4087D7" height={90} width={90} className="deposit__loader" />
        </div>
      </div>
    );
  }

  renderStepThree() {
    return (
      <form className="deposit deposit--success" 
// @ts-ignore
      onSubmit={this.onDone} >
        <div className="deposit__section deposit__section--wider">
          <h3 className="deposit__title">Deposit Request Sent!</h3>
        </div>
        <div className="deposit__divider" />
        <div className="deposit__section deposit__section--wider">
          <div className="deposit__paragraph deposit__paragraph--full-width">
            Your deposit request has been sent to your bank. It may take up to 24 hours. A notification will be sent once complete.
          </div>
        </div>
        <div className="deposit__divider" />
        <div className="deposit__actions">
          <ButtonGroup noGutter>
            <
// @ts-ignore
            Button  size='sml' type="submit" label="Done" customClassNames={['deposit__action', 'button--wide']} />
          </ButtonGroup>
        </div>
      </form>
    );
  }

  render() {
    switch (this.state.step) {
      default: return this.renderStepZero();
      case 1:  return this.renderStepOne();
      case 2:  return this.renderStepTwo();
      case 3:  return this.renderStepThree();
    }
  }
}

export default Deposit;
